export async function GetCompetitionProds(
  page,
  limit,
  searchEan,
  searchName,
  isActivate,
  isPrzypisane,
) {
  const response = await fetch(
    `https://hs2api.razamit.pl/getProdsList?page=${page}&limit=${limit}&searchEan=${searchEan}&searchName=${searchName}&isActivate=${isActivate}&isPrzypisane=${isPrzypisane}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return data;
}
export async function GetCompetitionProdsMissing(page, limit, searchEan) {
  const response = await fetch(
    `https://hs2api.razamit.pl/getProdsListMissing?page=${page}&limit=${limit}&searchEan=${searchEan}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return data;
}
export async function GetAddedIndexToUser(userId) {
  const response = await fetch(
    `https://hs2api.razamit.pl/GetIndexTouserAdded?userId=${userId}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz. 51",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}

export async function GetAdedUsersToIndex(indexId) {
  const response = await fetch(
    `https://hs2api.razamit.pl/GetUsersAddBrand?indexId=${indexId}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}

export async function saveUserIndex(userId, indexId) {
  const response = await fetch(`https://hs2api.razamit.pl/saveUserIndex`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      userId: userId,
      indexId: indexId,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}

export async function SearchUsers(text) {
  const response = await fetch(
    `https://hs2api.razamit.pl/SearchUsers?search=${text}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}
export async function GetBrandlyData(page, limit) {
  const response = await fetch(`https://hs2api.razamit.pl/RunDataApiBrandly`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();

  return { data };
}
export async function removeAddedUser(userId, indexid) {
  console.log("removeAddedUser userId:", userId, "indexid:", indexid);

  const response = await fetch(
    `https://hs2api.razamit.pl/removeAddedUsertoCompetitionIndex`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userId,
        indexId: indexid,
      }),
    },
  );
  if (!response.ok) {
    // const errorData = await response.json().catch(() => ({}));
    const error = new Error(
      "Error:".errorData.error ||
        "Błąd w zapytaniu. Popraw zapytnie i spróbuj jeszcze raz.",
    );
    error.status = response.status;
    throw error;
  }
}
